// @flow
import { ApiBase } from "api/api";
import {
  makeDeleteRequest,
  makePostRequest,
  makePutRequest,
} from "api/fetchCalls";
import type { CreateCustomerField, CustomerField } from "types/customerField";

export async function createCustomerField(
  data: CreateCustomerField,
): Promise<CustomerField> {
  return await makePostRequest(ApiBase + "/customer_fields", { body: data });
}

export async function updateCustomerField(
  data: CustomerField,
): Promise<CustomerField> {
  return await makePutRequest(ApiBase + `/customer_fields/${data.id}`, {
    body: data,
  });
}

export async function deleteCustomerField(id: string): Promise<void> {
  return await makeDeleteRequest(ApiBase + `/customer_fields/${id}`);
}
